import React from "react";
import {Row} from 'react-bootstrap';

function STCRow(props){

    return(
        <Row
            style={props.style}
            className={props.className}
            align={props.align}

            onClick={props.onClick}
            as={props.as}
            lg={props.lg}
            md={props.md}
            sm={props.sm}
            xl={props.xl}
            xs={props.xs}
            xxl={props.xxl}
            bsPrefix={props.bsPrefix}
        >
            {props.children}
        </Row>
    )
}
export default STCRow;